import AssistantResponseCard from "./AssistantResponseCard";

export default function AssistantMessage({ msg }) {
    return <AssistantResponseCard 
        rawText={msg.text} 
        timestamp={msg.timestamp}
        sources={msg.sources || []}
    />;
}